
(function(){
  setTimeout(function(){
    document.querySelectorAll('.lf3-wrap').forEach(function(w){
      if(w.dataset.lf3) return; w.dataset.lf3='1';

      var btn   = w.querySelector('.js-lf3-btn');
      var modal = w.querySelector('.js-lf3-modal');
      var close = w.querySelector('.js-lf3-close');
      var cart  = w.querySelector('.js-lf3-cart');
      if(!btn||!modal) return;

      function open(e){ if(e){e.preventDefault();} modal.classList.add('is-open'); document.body.style.overflow='hidden'; }
      function shut(e){ if(e){e.preventDefault();} modal.classList.remove('is-open'); document.body.style.overflow=''; }

      btn.addEventListener('click', open);
      if(close) close.addEventListener('click', shut);
      modal.addEventListener('click', function(e){ if(e.target===modal) shut(e); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') shut(); });

      /* FAQ-Accordion */
      w.querySelectorAll('.js-faq-q').forEach(function(q){
        q.addEventListener('click', function(e){
          e.preventDefault();
          var item = q.closest('.lf3-faq-item');
          var openItem = w.querySelector('.lf3-faq-item.is-open');
          if(openItem && openItem!==item) openItem.classList.remove('is-open');
          item.classList.toggle('is-open');
        });
      });

      /* In den Warenkorb: klickt den ECHTEN Add-to-Cart-Button -> erbt euren Cart-Slider */
      function triggerAddToCart(){
        var selectors = [
          'form[action*="/cart/add"] [type="submit"]',
          'form[action*="/cart/add"] [name="add"]',
          'button[name="add"]',
          '.product-form__submit',
          '.product-form button[type="submit"]',
          'form[action*="/cart/add"] button'
        ];
        for(var i=0;i<selectors.length;i++){
          var el=document.querySelector(selectors[i]);
          if(el && !el.closest('.lf3-wrap')){ el.click(); return true; }
        }
        /* Fallback: irgendein Button mit "Warenkorb" im Text (ausserhalb unseres Elements) */
        var all=document.querySelectorAll('button, input[type="submit"]');
        for(var j=0;j<all.length;j++){
          var t=(all[j].textContent||all[j].value||'').toLowerCase();
          if(t.indexOf('warenkorb')>-1 && !all[j].closest('.lf3-wrap')){ all[j].click(); return true; }
        }
        return false;
      }

      if(cart){
        cart.addEventListener('click', function(e){
          e.preventDefault();
          shut();                 /* Modal zu, damit der Cart-Slider frei sichtbar ist */
          triggerAddToCart();     /* echter Add-to-Cart -> Slider oeffnet */
        });
      }

    });
  },100);
})();

;

(function(){
  setTimeout(function(){
    document.querySelectorAll('.lf4-wrap').forEach(function(w){
      if(w.dataset.lf4) return; w.dataset.lf4='1';

      var btn   = w.querySelector('.js-lf4-btn');
      var modal = w.querySelector('.js-lf4-modal');
      var close = w.querySelector('.js-lf4-close');
      var cart  = w.querySelector('.js-lf4-cart');
      if(!btn||!modal) return;

      function open(e){ if(e){e.preventDefault();} modal.classList.add('is-open'); document.body.style.overflow='hidden'; }
      function shut(e){ if(e){e.preventDefault();} modal.classList.remove('is-open'); document.body.style.overflow=''; }

      btn.addEventListener('click', open);
      if(close) close.addEventListener('click', shut);
      modal.addEventListener('click', function(e){ if(e.target===modal) shut(e); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') shut(); });

      /* FAQ-Accordion */
      w.querySelectorAll('.js-lf4-faq-q').forEach(function(q){
        q.addEventListener('click', function(e){
          e.preventDefault();
          var item = q.closest('.lf4-faq-item');
          var openItem = w.querySelector('.lf4-faq-item.is-open');
          if(openItem && openItem!==item) openItem.classList.remove('is-open');
          item.classList.toggle('is-open');
        });
      });

      /* In den Warenkorb */
      function triggerAddToCart(){
        var selectors = [
          'form[action*="/cart/add"] [type="submit"]',
          'form[action*="/cart/add"] [name="add"]',
          'button[name="add"]',
          '.product-form__submit',
          '.product-form button[type="submit"]',
          'form[action*="/cart/add"] button'
        ];
        for(var i=0;i<selectors.length;i++){
          var el=document.querySelector(selectors[i]);
          if(el && !el.closest('.lf4-wrap')){ el.click(); return true; }
        }
        var all=document.querySelectorAll('button, input[type="submit"]');
        for(var j=0;j<all.length;j++){
          var t=(all[j].textContent||all[j].value||'').toLowerCase();
          if(t.indexOf('warenkorb')>-1 && !all[j].closest('.lf4-wrap')){ all[j].click(); return true; }
        }
        return false;
      }

      if(cart){
        cart.addEventListener('click', function(e){
          e.preventDefault();
          shut();                 
          triggerAddToCart();     
        });
      }

    });
  },100);
})();

;
document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        if (typeof Swiper === 'undefined') return;

        // 1. POPUP DUPLIKAT- & MOBILE-FIX
        // Nimm das erste Popup, das existiert, und schiebe es GANZ NACH OBEN in den Body.
        // Dadurch kann PageFly es auf dem Handy nicht mehr verstecken!
        let overlay = document.querySelector('.people_popup_overlay_new');
        let popupBox = document.querySelector('.meta_real_reviews_mainpopup_new');

        if (overlay && popupBox && !overlay.classList.contains('is-moved')) {
            document.body.appendChild(overlay);
            document.body.appendChild(popupBox);
            overlay.classList.add('is-moved');
            popupBox.classList.add('is-moved');
        }

        // Lösche alle anderen, überflüssigen Popups (weil du den Code 2x eingebunden hast)
        document.querySelectorAll('.im8-component-wrapper .meta_real_reviews_mainpopup_new').forEach(el => el.remove());
        document.querySelectorAll('.im8-component-wrapper .people_popup_overlay_new').forEach(el => el.remove());

        // 2. SLIDER INITIALISIEREN
        const wrappers = document.querySelectorAll('.im8-component-wrapper');
        wrappers.forEach(wrapper => {
            if (wrapper.dataset.initialized) return;
            wrapper.dataset.initialized = 'true';

            const sliderEl = wrapper.querySelector('.im8-video-slider');
            new Swiper(sliderEl, {
                slidesPerView: 4, // Wieder auf 4!
                spaceBetween: 12,
                grabCursor: true,
                breakpoints: {
                    320: { slidesPerView: 3.2, spaceBetween: 8 }, // Mobile (etwas Anschnitt zum Wischen)
                    768: { slidesPerView: 4, spaceBetween: 12 }   // Desktop (Exakt 4, gestoppt durch max-width)
                }
            });
        });

        // Ab hier die Logik für das umgezogene Popup
        if (!popupBox) return;

        const popupInner = popupBox.querySelector('.meta_real_reviews_innerpopup_new');
        const popupVideo = popupBox.querySelector('video');
        const videoClickArea = popupBox.querySelector('.video-click-area');
        const closeBtn = popupBox.querySelector('.meta_real_reviews_mainclose_new');
        const muteToggleBtn = popupBox.querySelector('.mute-btn-wrapper');
        const btnPrev = popupBox.querySelector('.popup-prev');
        const btnNext = popupBox.querySelector('.popup-next');

        let currentVideoList = [];
        let currentIndex = 0;

        function loadAndPlayVideo(index) {
            currentIndex = index;
            popupVideo.src = currentVideoList[index].src;
            popupVideo.poster = currentVideoList[index].poster;

            btnPrev.style.display = (index === 0) ? 'none' : 'block';
            btnNext.style.display = (index === currentVideoList.length - 1) ? 'none' : 'block';

            popupInner.classList.remove('is-paused');
            popupVideo.muted = false;
            muteToggleBtn.classList.remove('is-muted');

            let playPromise = popupVideo.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    popupVideo.muted = true;
                    muteToggleBtn.classList.add('is-muted');
                    popupVideo.play();
                });
            }
        }

        // Klick-Events für ALLE Videos (Desktop & Mobile)
        document.addEventListener('click', function(e) {
            const trigger = e.target.closest('.custom-popup-trigger');
            if (trigger) {
                const wrapper = trigger.closest('.im8-component-wrapper');
                const allTriggers = wrapper.querySelectorAll('.custom-popup-trigger');

                currentVideoList = [];
                allTriggers.forEach((t) => {
                    currentVideoList.push({
                        src: t.getAttribute('data-video-src'),
                        poster: t.getAttribute('data-poster-src')
                    });
                });

                currentIndex = parseInt(trigger.getAttribute('data-index'));
                document.body.classList.add('popup-is-open');
                overlay.style.display = 'block';
                popupBox.style.display = 'block';
                loadAndPlayVideo(currentIndex);
            }
        });

        // Verhindert, dass die Buttons doppelt triggern, falls der Code 2x läuft
        if (!window.im8PopupEventsBound) {
            window.im8PopupEventsBound = true;

            btnNext.addEventListener('click', () => {
                if (currentIndex < currentVideoList.length - 1) loadAndPlayVideo(currentIndex + 1);
            });

            btnPrev.addEventListener('click', () => {
                if (currentIndex > 0) loadAndPlayVideo(currentIndex - 1);
            });

            videoClickArea.addEventListener('click', () => {
                if (popupVideo.paused) {
                    popupVideo.play();
                    popupInner.classList.remove('is-paused');
                } else {
                    popupVideo.pause();
                    popupInner.classList.add('is-paused');
                }
            });

            function closePopup() {
                popupVideo.pause();
                popupVideo.src = '';
                popupInner.classList.remove('is-paused');
                overlay.style.display = 'none';
                popupBox.style.display = 'none';
                document.body.classList.remove('popup-is-open');
            }

            closeBtn.addEventListener('click', closePopup);
            overlay.addEventListener('click', closePopup);

            muteToggleBtn.addEventListener('click', function() {
                if (popupVideo.muted) {
                    popupVideo.muted = false;
                    this.classList.remove('is-muted');
                } else {
                    popupVideo.muted = true;
                    this.classList.add('is-muted');
                }
            });

            document.addEventListener('keydown', function(event) {
                if (popupBox.style.display === 'block') {
                    if (event.key === 'Escape') closePopup();
                    else if (event.key === 'ArrowRight') btnNext.click();
                    else if (event.key === 'ArrowLeft') btnPrev.click();
                }
            });
        }

    }, 500);
});
/* Accordéons PageFly (Accordion3) : le script PageFly n'est pas chargé ici ; le CSS ouvre l'onglet via la classe .open (comme lefaya.de) */
(function(){
  var SEL='details[data-pf-type="Accordion3.Content.Wrapper"]';
  function sync(d){ d.classList.toggle('open', d.open); }
  document.addEventListener('toggle', function(e){ if(e.target.matches && e.target.matches(SEL)) sync(e.target); }, true);
  function init(){ document.querySelectorAll(SEL).forEach(sync); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
